import Images from '@assets/images';
import { Accordion, Button, Typography } from '@components/base';
import { Avatar } from '@components/common';
import { AppContext } from '@helpers/hooks/AppContext';
import { useContext, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/footer';
import css from './index.module.scss';
import { ITaskTabProps } from '@helpers/types/task-tabs';
import { Link } from 'react-router-dom';

interface IBOLCard {
  taskData: Partial<ITaskTabProps>;
}

const GenerateBOLCard = (props: IBOLCard) => {
  const navigate = useNavigate();
  const { appDispatch } = useContext(AppContext);
  const { taskData } = props;
  return (
    <div className={css.mainWrapper}>
      <Accordion defaultExpanded>
        <Accordion.Header className={css.accordionHeader}>
          <div className={css.header}>
            <div className={css.wrapper}>
              {!taskData?.is_completed ? (
                <Avatar src={Images.illustrationEdit} alt="" />
              ) : (
                <Avatar src={Images.alertSuccessFaint} alt="" />
              )}

              <Link to={`/order/${taskData?.order}`} style={{ textDecoration: 'none' }}>
                <Typography variant="h5" className={css.underlineOnHover}>
                  #{taskData?.readable_task_id} - Generate Bill of Lading
                </Typography>
              </Link>
            </div>
            <div className={css.pocWrapper}>
              {!taskData?.is_completed && (
                <Button
                  variant="text"
                  onClick={() => {
                    navigate(
                      `/order/generate-bill-of-lading/${taskData?.order}/${taskData?.task_id}`
                    );
                  }}
                  className={css.assignButton}
                >
                  Generate Form
                </Button>
              )}
            </div>
          </div>
        </Accordion.Header>
      </Accordion>
      <Footer createdDate={taskData.created_at as Date} updatedDate={taskData.updated_at as Date} />
    </div>
  );
};

export default GenerateBOLCard;
